import { render, staticRenderFns } from "./DtTecnicas.vue?vue&type=template&id=5c1f1e36&scoped=true"
import script from "./DtTecnicas.vue?vue&type=script&lang=js"
export * from "./DtTecnicas.vue?vue&type=script&lang=js"
import style0 from "./DtTecnicas.vue?vue&type=style&index=0&id=5c1f1e36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1f1e36",
  null
  
)

export default component.exports